import { useEffect } from 'react';
import { displayAddress, type V2Inspection } from '../../domain/inspection';
import { useT } from '../../i18n/i18n';
import { useCoverPhotoUrl } from '../../state/coverPhoto';
import { useBackHandler } from '../../ui/backStack';
import { Portal } from '../../ui/components';
import { useBodyScrollLock } from '../../ui/scrollLock';

// Full-screen view of the report cover photo (Owner 2026-09-14: 「报告左边图像这里要有缩略图，点击可
// 放大」). A viewer only — no note, no delete: changing the cover is done from the inspection card.
// Four ways out, all the same close (popup rule): the Close button, a tap anywhere on the stage, Escape,
// and the caller unmounting it.
export function CoverPhotoViewer(props: { inspection: V2Inspection; onClose: () => void }) {
  const { t } = useT();
  const url = useCoverPhotoUrl(props.inspection, 'full');
  useBodyScrollLock();
  useBackHandler(props.onClose);

  useEffect(() => {
    function onKey(event: KeyboardEvent) {
      if (event.key === 'Escape') props.onClose();
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [props]);

  return (
    <Portal>
      <div className="lightbox cover-viewer" role="dialog" aria-label={t('cover.viewer')} data-testid="cover-viewer" data-overlay="lightbox">
        <div className="lightbox-top">
          <span className="lightbox-counter">{t('cover.viewer')}</span>
          <button type="button" onClick={props.onClose} data-testid="cover-viewer-close">
            {t('shell.close')}
          </button>
        </div>
        <button type="button" className="lightbox-stage cover-viewer-stage" onClick={props.onClose} aria-label={t('shell.close')} data-testid="cover-viewer-stage">
          {url ? <img src={url} alt="" draggable={false} data-testid="cover-viewer-image" /> : <span>{t('shell.loading')}</span>}
        </button>
        <p className="lightbox-hint" data-testid="cover-viewer-address">
          {displayAddress(props.inspection, t('inspection.noAddress'))}
        </p>
      </div>
    </Portal>
  );
}
